/**
 * addit Theme — Cart Drawer
 * Slide-in cart with AJAX quantity updates, section rendering API refresh,
 * and a public window.CartDrawer API for integration with product.js
 */
(function () {
  'use strict';

  var drawer  = document.querySelector('[data-cart-drawer]');
  var overlay = document.querySelector('[data-cart-overlay]');

  /* ==========================================================================
     Open / Close  (null-safe — work even if drawer hasn't rendered)
     ========================================================================== */
  function open() {
    if (!drawer || !overlay) return;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    overlay.classList.add('is-visible');
    document.body.classList.add('drawer-open');
    var closeBtn = drawer.querySelector('[data-cart-close]');
    if (closeBtn) closeBtn.focus();
  }

  function close() {
    if (!drawer || !overlay) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    overlay.classList.remove('is-visible');
    document.body.classList.remove('drawer-open');
  }

  /* ==========================================================================
     Section Rendering API — swaps [data-cart-drawer-content] with fresh HTML
     ========================================================================== */
  function refresh(callback) {
    if (!drawer) { if (callback) callback(); return; }
    fetch('/?sections=cart-drawer')
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (!data['cart-drawer']) { if (callback) callback(); return; }

        var parser     = new DOMParser();
        var doc        = parser.parseFromString(data['cart-drawer'], 'text/html');
        var newContent = doc.querySelector('[data-cart-drawer-content]');
        var curContent = drawer.querySelector('[data-cart-drawer-content]');
        if (newContent && curContent) curContent.innerHTML = newContent.innerHTML;

        // Sync drawer count badge
        var newBadge = doc.querySelector('[data-drawer-count-badge]');
        var curBadge = drawer.querySelector('[data-drawer-count-badge]');
        if (newBadge && curBadge) {
          curBadge.textContent = newBadge.textContent;
          curBadge.classList.toggle('is-hidden', newBadge.classList.contains('is-hidden'));
        }

        // Sync header cart count
        if (newBadge) {
          var n = parseInt(newBadge.textContent, 10) || 0;
          var headerCount = document.querySelector('[data-cart-count]');
          if (headerCount) {
            headerCount.textContent = n;
            headerCount.classList.toggle('is-hidden', n === 0);
          }
        }

        if (callback) callback();
      })
      .catch(function () { if (callback) callback(); });
  }

  /* ==========================================================================
     Helpers
     ========================================================================== */
  function formatMoney(cents) {
    return (cents / 100).toFixed(2).replace('.', ',') + '\u00a0€';
  }

  function renumberLines() {
    if (!drawer) return;
    drawer.querySelectorAll('[data-cart-item]').forEach(function (el, i) {
      var n = i + 1;
      el.setAttribute('data-line', n);
      var btn = el.querySelector('[data-remove-line]');
      if (btn) btn.setAttribute('data-remove-line', n);
    });
  }

  /* ==========================================================================
     AJAX cart change
     ========================================================================== */
  function cartChange(line, qty, itemEl) {
    fetch('/cart/change.json', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ line: line, quantity: qty })
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var headerCount = document.querySelector('[data-cart-count]');
        if (headerCount) {
          headerCount.textContent = data.item_count;
          headerCount.classList.toggle('is-hidden', data.item_count === 0);
        }
        var curBadge = drawer ? drawer.querySelector('[data-drawer-count-badge]') : null;
        if (curBadge) {
          curBadge.textContent = data.item_count;
          curBadge.classList.toggle('is-hidden', data.item_count === 0);
        }

        if (data.item_count === 0) { refresh(); return; }

        if (qty === 0) {
          if (itemEl) itemEl.remove();
          renumberLines();
        } else {
          if (itemEl) {
            itemEl.classList.remove('is-loading');
            var priceEl = itemEl.querySelector('[data-line-price]');
            var updated = data.items[line - 1];
            if (priceEl && updated) priceEl.textContent = formatMoney(updated.final_line_price);
          }
        }

        var totalEl = drawer ? drawer.querySelector('[data-cart-total]') : null;
        if (totalEl) totalEl.textContent = formatMoney(data.total_price);
      })
      .catch(function () { if (itemEl) itemEl.classList.remove('is-loading'); });
  }

  /* ==========================================================================
     Event listeners — ALL set up unconditionally (no early return above)
     ========================================================================== */

  // 1. Cart icon → open drawer (prevent navigation to /cart page)
  //    On the /cart page itself, let the link navigate normally.
  document.addEventListener('click', function (e) {
    var cartLink = e.target.closest('[data-cart-link]');
    if (!cartLink) return;
    if (document.body.classList.contains('template-cart')) return;
    if (!drawer) return; // drawer didn't render — fallback to normal navigation
    e.preventDefault();
    open();
  });

  // 2. Close button or overlay
  document.addEventListener('click', function (e) {
    if (!drawer || !overlay) return;
    if (e.target.closest('[data-cart-close]') || e.target === overlay) close();
  });

  // 3. ESC key
  document.addEventListener('keydown', function (e) {
    if (!drawer) return;
    if (e.key === 'Escape' && drawer.classList.contains('is-open')) close();
  });

  // 4. Quantity +/- (scoped to drawer)
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-qty-btn]');
    if (!btn || !drawer || !drawer.contains(btn)) return;
    var itemEl = btn.closest('[data-cart-item]');
    if (!itemEl) return;
    var line   = parseInt(itemEl.getAttribute('data-line'), 10);
    var input  = itemEl.querySelector('input');
    var delta  = parseInt(btn.getAttribute('data-delta'), 10);
    var newQty = Math.max(0, parseInt(input.value, 10) + delta);
    input.value = newQty;
    itemEl.classList.add('is-loading');
    cartChange(line, newQty, itemEl);
  });

  // 5. Remove button (scoped to drawer)
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-remove-line]');
    if (!btn || !drawer || !drawer.contains(btn)) return;
    e.preventDefault();
    var itemEl = btn.closest('[data-cart-item]');
    var line   = parseInt(btn.getAttribute('data-remove-line'), 10);
    if (itemEl) itemEl.classList.add('is-loading');
    cartChange(line, 0, itemEl);
  });

  // 6. Bundle quantity +/- (changes all components proportionally)
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-bundle-qty-btn]');
    if (!btn) return;
    e.preventDefault();

    var bundleId = btn.getAttribute('data-bundle-id');
    var bundleEl = btn.closest('[data-bundle-id]');
    var delta = parseInt(btn.getAttribute('data-delta'), 10);

    if (bundleEl) bundleEl.style.opacity = '0.4';

    /* Always read current state from cart API (single source of truth) */
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        /* Find all components for this bundle and their base quantities */
        var components = [];
        cart.items.forEach(function (item) {
          if (item.properties && item.properties['_bundle_id'] === bundleId) {
            components.push(item);
          }
        });
        if (!components.length) { refresh(); return; }

        /* Determine current set count from the first component's quantity
           divided by its per-set quantity (stored as the smallest component qty at set=1).
           Since all components scale equally, use the first one. */
        var first = components[0];
        /* Find base qty per set: component data from bundle-contents has per-set quantities.
           We need the count from data attribute, but that's on the Liquid side.
           Simple approach: read from data-bundle-components to know how many components,
           and infer set count. With equal-qty components, setCount = first.quantity */
        var compCount = bundleEl ? parseInt(bundleEl.getAttribute('data-bundle-components'), 10) : components.length;

        /* All components in this bundle were added with the same qty per set (1 each).
           So set count = first component's quantity / 1 = first.quantity.
           For bundles with unequal per-set quantities, we'd need stored base qtys,
           but the Founder Set uses 1× each. */
        var setCount = first.quantity;
        var newSetCount = Math.max(0, setCount + delta);

        var updates = {};
        components.forEach(function (item) {
          var perSet = Math.round(item.quantity / setCount);
          updates[item.key] = perSet * newSetCount;
        });

        return fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ updates: updates })
        });
      })
      .then(function () { refresh(); })
      .catch(function () { if (bundleEl) bundleEl.style.opacity = '1'; });
  });

  /* ==========================================================================
     Public API — called by product.js after add-to-cart
     ========================================================================== */
  window.CartDrawer = {
    open: function (shouldRefresh) {
      open();
      if (shouldRefresh && drawer) {
        var contentEl = drawer.querySelector('[data-cart-drawer-content]');
        if (contentEl) contentEl.classList.add('is-refreshing');
        refresh(function () {
          if (contentEl) contentEl.classList.remove('is-refreshing');
        });
      }
    },
    close: close,
    refresh: refresh
  };
})();
